import XLSX from 'xlsx';

export const Xlsx = async function (file) {
  let fileInfo = { raw: [], data: [], type: "" }
  //let code = await judgmentCode(file);
  await readFile(file, fileInfo);
  // typePrediction(fileInfo);
  return fileInfo;
}

function readFile(file, fileInfo) {
  return new Promise((resolve) => {
    const fileReader = new FileReader()
    fileReader.onload = (ev) => {
      try {
        const data = ev.target.result
        const workbook = XLSX.read(data, {
          type: 'binary'
        }) // 读取数据

        fileInfo.raw = workbook;

        // console.log(workbook)
        // const wsname = workbook.SheetNames[0] // 取第一张表
        // console.log(wsname)
        // const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) // 生成json表格内容
        // console.log(ws)
        // const ws1 = XLSX.utils.sheet_to_slk(workbook.Sheets[wsname]) // 输出表格对应位置是什么值
        // const ws2 = XLSX.utils.sheet_to_html(workbook.Sheets[wsname]) // 生成HTML输出
        // const ws3 = XLSX.utils.sheet_to_csv(workbook.Sheets[wsname]) // 生成分隔符分隔值输出
        // const ws4 = XLSX.utils.sheet_to_formulae(workbook.Sheets[wsname]) // 生成公式列表（具有值回退）
        // const ws5 = XLSX.utils.sheet_to_txt(workbook.Sheets[wsname]) // 生成UTF16格式的文本

        workbook.SheetNames.forEach(sheet => {
          fileInfo.data.push({
            type: sheet,
            data: XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
          })
        })

        switch (workbook.SheetNames.join(",")) {
          case "支出记录,收入记录,转账记录":
            fileInfo.type = "叨叨记账";
            break;
          case "支出,收入,转账":
            fileInfo.type = "网易有钱";
            break;
          case "收支记录,借入借出,固收理财":
            fileInfo.type = "口袋记账";
            break;
        }
      } catch (e) {
        return false
      }

      resolve();
    }
    fileReader.readAsBinaryString(file)
  });
}

// function typePrediction(fileInfo) {
//   console.log(fileInfo.raw)
//   switch (fileInfo.raw.SheetNames.join(",")) {
//     case "支出记录,收入记录,转账记录":
//       fileInfo.type = "叨叨记账";
//       break;
//     case "支出,收入,转账":
//       fileInfo.type = "网易有钱";
//       break;
//   }
// }